$(document).on("metaslug_sinhnhat1tuoi_event rendered", {}, function (event, uniqueId) {
  var $this = $("#" + uniqueId);

  // console.log(event);
  // console.log(uniqueId);
  // console.log($this);
  var swiper = new Swiper('.swiper', {
    //loop: true, // Cho phép lặp vô hạn
    slidesPerView: 2, // Hiển thị hai slide cùng một lúc
    spaceBetween: 0, // Khoảng cách giữa các slide
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // autoplay: {
    //   delay: 5000, // Tự động chuyển slide sau mỗi 5 giây
    // },
    breakpoints: {
      999: {
        slidesPerView: 3 // Hiển thị một slide trên màn hình có chiều rộng <= 768px
      }

    }
  });
});